import script from "./addon.vue?vue&type=script&lang=js"
export * from "./addon.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__